"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useState, useCallback } from "react";
import Api from "../Jobs/API";
export const useEntityFilterOptions = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchData = useCallback((archived) => __async(void 0, null, function* () {
    var _a;
    setIsLoading(true);
    try {
      let page = 1;
      let totalPages = 9999;
      let results = [];
      while (page <= totalPages) {
        const response = yield Api.getJobFilterOptionsPaginated("entities", {
          "filter[archived]": archived,
          page
        });
        const currentPageData = response.res.entities || [];
        results = [...results, ...currentPageData];
        if (page === 1) {
          const transformedResults = results.map((entity) => ({
            id: entity.id,
            name: entity.name
          }));
          setData(transformedResults);
        }
        totalPages = parseInt(((_a = response.resHead) == null ? void 0 : _a["x-total-pages"]) || "1");
        page += 1;
      }
      if (page > 1) {
        const transformedResults = results.map((entity) => ({
          id: entity.id,
          name: entity.name
        }));
        setData(transformedResults);
      }
    } catch (error) {
      console.error("Error fetching entities:", error);
    } finally {
      setIsLoading(false);
    }
  }), []);
  return { data, isLoading, fetchData };
};
